import { carousel } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">精选深度内容，带你发现漫画世界的更多精彩</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carousel.map((item, index) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => e.preventDefault()}
              className={`group block bg-background-100 rounded-2xl overflow-hidden border border-background-200/50 hover:border-primary-200/60 transition-all cursor-pointer ${
                index === 0 ? 'lg:col-span-3' : ''
              } ${index === 1 || index === 2 ? 'lg:col-span-1' : ''} ${index >= 3 ? 'lg:col-span-1' : ''}`}
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[21/9] md:aspect-[21/8]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.subtitle}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}